import React from "react";
import { Modal, Button, Card } from "antd";
import { InvoiceData, Booking } from "../../types";

interface InvoicePreviewModalProps {
  invoicePreview: InvoiceData | null;
  isPreviewModalVisible: boolean;
  setIsPreviewModalVisible: (value: boolean) => void;
  handleConfirmInvoice: () => void;
  isCreatingInvoice: boolean;
  booking: Booking | undefined;
}

export const InvoicePreviewModal: React.FC<InvoicePreviewModalProps> = ({
  invoicePreview,
  isPreviewModalVisible,
  setIsPreviewModalVisible,
  handleConfirmInvoice,
  isCreatingInvoice,
  booking,
}) => {
  if (!invoicePreview || !booking) return null;

  return (
    <Modal
      title="Invoice Preview"
      open={isPreviewModalVisible}
      width={700}
      onCancel={() => setIsPreviewModalVisible(false)}
      footer={[
        <Button key="back" onClick={() => setIsPreviewModalVisible(false)}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleConfirmInvoice}
          loading={isCreatingInvoice}
        >
          Create Invoice
        </Button>,
      ]}
    >
      <Card className="mb-4">
        <div className="flex justify-between mb-4">
          <div>
            <h3 className="text-lg font-medium">
              Invoice for {booking.client?.companyName ?? "N/A"}
            </h3>
            <p>Booking Reference: {booking.bookingReference}</p>
            <p>Date: {new Date().toLocaleDateString()}</p>
          </div>
          <div className="text-right">
            <p>
              <strong>Art Handler Company</strong>
            </p>
            <p>123 Art St, New York, NY</p>
            <p>info@arthandlercompany.com</p>
          </div>
        </div>
        <table className="w-full text-sm mt-6">
          <thead>
            <tr className="border-b border-t">
              <th className="py-2 text-left">Description</th>
              <th className="py-2 text-right">Amount</th>
            </tr>
          </thead>
          <tbody>
            {invoicePreview.Line.map((item, index) => (
              <tr key={index} className="border-b">
                <td className="py-2">{item.Description}</td>
                <td className="py-2 text-right">${item.Amount.toFixed(2)}</td>
              </tr>
            ))}
            <tr className="font-medium text-lg">
              <td className="py-2">Total</td>
              <td className="py-2 text-right">
                $
                {invoicePreview.Line.reduce(
                  (sum: number, item) => sum + item.Amount,
                  0
                ).toFixed(2)}
              </td>
            </tr>
          </tbody>
        </table>
      </Card>
      <p className="text-sm text-gray-600">
        This invoice will be created in QuickBooks and associated with the
        selected services. A payment link will be generated and can be sent to
        the client.
      </p>
    </Modal>
  );
};
